import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeletePickingFileActions } from "store/ducks/picking-files";

export function* deletePickingFileRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.delete,
      `/picking-files/${id}`
    );

    const { data } = responseBody;
    yield put(DeletePickingFileActions.success(data));
    notify("success", "Documento deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeletePickingFileActions.failure(errorMessage));
  }
}
